import React, { useState } from "react";
import CameraScanner from "components/BarcodeScanner/cameraScanner.jsx";
import ManualScanner from "components/BarcodeScanner/manualScanner.jsx";
import BarcodeQtyGridContainer from "containers/BarcodeQtyGridContainer.jsx";
import ScannerLogs from "components/ScannerLogs";
import Barcodegif from "assets/images/barcodescan.gif";

const ScanDetailsContainer = ({
  isCameraScan,
  isManualMode,
  isScanning,
  setIsScanning,
  successCallbackFn,
  isQtyGridLoading,
  barcodeSubmit,
}) => {
  const [scannerGif, setScannerGif] = useState(false);

  const showScannerGif = () => { setScannerGif(true) };
  const hideScannerGif = () => { setScannerGif(false) };

  return (
    <div>
      {isCameraScan && (
        <CameraScanner
          isScanning={isScanning}
          setIsScanning={setIsScanning}
          successCallbackFn={successCallbackFn}
        />
      )}
      {!isCameraScan && (
        <ManualScanner
          barcodeSubmit={barcodeSubmit}
          showScannerGif={showScannerGif}
          hideScannerGif={hideScannerGif}
          scannerGif={scannerGif}
          Barcodegif={Barcodegif}
        />
      )}

      {isManualMode && !isScanning && (
        <div className="d-flex justify-content-center" >
          <BarcodeQtyGridContainer isLoading={isQtyGridLoading} />
        </div>
      )}
      {!isManualMode && (
        <div
          className="w-50 mx-auto mt-4 mb-4 scan-log-container overflow-auto"
          style={{ maxHeight: "85vh" }}
        >
          <ScannerLogs />
        </div>
      )}
    </div>
  );
};

export default React.memo(ScanDetailsContainer);
